<template>
  <div id="app">
    <loading ref="loading"/>
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        this.$loading = this.$refs.loading;
    },
}
</script>

<style>
  @import './styles/app.scss';
</style>

